'use client'

import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { BarChart3 } from 'lucide-react'
import { lazy, Suspense } from 'react'

const WeeklyChartCard = lazy(() => import('@/components/ui/weekly-chart-card').then(mod => ({ default: mod.WeeklyChartCard })))

interface WeeklyActivityWidgetProps {
  title: string
  data: any[]
  totalHours: number
  loading?: boolean
}

export function WeeklyActivityWidget({ title, data, totalHours, loading }: WeeklyActivityWidgetProps) {
  return (
    <Suspense fallback={<Card><CardContent className="p-6"><Skeleton className="h-64 w-full" /></CardContent></Card>}>
      <WeeklyChartCard
        title={title}
        icon={BarChart3}
        data={data}
        totalHours={totalHours}
        loading={loading}
      />
    </Suspense>
  )
}
